/**
 * Точность результата геокодера Яндекса.
 *
 * `GeocoderMetaData.precision`: 'exact' — точное совпадение с домом, 'number' — дом
 * найден по номеру, 'near' — ближайший дом, 'range' — участок улицы, 'street' —
 * только улица, 'other' — населённый пункт и крупнее. Окно карты раньше принимало
 * ЛЮБОЙ результат с координатами: строка «станица Новотитаровская» давала центр
 * станицы, он лежал в зоне 1 и сохранялся как адрес доставки (кластер из 5 адресов
 * пяти клиентов в одной точке, заказ 7994). Адрес доставки — это дом: без него
 * курьеру ехать некуда.
 */

export interface GeocoderResultLike {
  /** Компонент kind='house' из ответа геокодера. */
  house?: string | null
  /** GeocoderMetaData.precision. */
  precision?: string | null
}

/** Точности, при которых геокодер ручается за дом даже без явного компонента house. */
export const HOUSE_LEVEL_PRECISIONS: readonly string[] = ['exact', 'number']

/**
 * Результат геокодера описывает конкретный дом: есть компонент «дом» либо точность
 * exact/number. Улица, участок улицы, населённый пункт — не адрес доставки.
 */
export function isHouseLevelResult(result: GeocoderResultLike | null | undefined): boolean {
  if (!result) return false
  if ((result.house ?? '').trim() !== '') return true
  return HOUSE_LEVEL_PRECISIONS.includes(result.precision ?? '')
}
